.link-context-menu__wrapper {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.link-context-menu__input {
  appearance: none;
  background-color: transparent;
  border: 2px solid var(--color-navy-600);
  border-radius: 0.5rem;
  color: var(--color-uva-black);
  font-family: inherit;
  font-size: inherit;
  height: 2.5rem;
  margin: 0 0.5rem 0 0;
  min-width: 20rem;
  padding: 0 0.5rem;
}

.link-context-menu__input:disabled {
  border-color: transparent;
}

.link-context-menu__button {
  aspect-ratio: 1;
  background-color: transparent;
  border: none;
  border-radius: 0.5rem;
  color: var(--color-uva-black);
  cursor: pointer;
  font-size: inherit;
  height: 2.5rem;
}

.link-context-menu__actions {
  align-items: center;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1rem;
}
